var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7501L8.39669 16.9255L9.34544 12.8238L6.16377 10.0638L10.3613 9.70922L12 5.83755L13.6388 9.70922L17.8363 10.0638L14.6546 12.8238L15.6034 16.9255M21.5834 8.8563L14.6929 8.27172L12 1.91797L9.3071 8.27172L2.41669 8.8563L7.6396 13.3892L6.07752 20.1263L12 16.5517L17.9225 20.1263L16.3509 13.3892L21.5834 8.8563Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiStarOutline);
export default __webpack_public_path__ + "static/media/mdi_star-outline.4d6a42b6ff8b53763244aa62cbb477ed.svg";
export { ForwardRef as ReactComponent };